<!-- Overrides @basecom-gmbh/pond/components/Cms/Element/CmsElementCrossSelling.vue -->
<script setup lang="ts">
import type { Schemas } from '@shopware/api-client/api-types';

const props = defineProps<{
    element: CmsElementCrossSelling;
}>();

const config = useCmsElementConfig(props.element);
const elementData = useCmsElementData(props.element);
const { trackSelectItem } = useAnalytics();

const boxLayout = config.getConfigValue('boxLayout');
const displayMode = config.getConfigValue('displayMode');
const minWidth = config.getConfigValue('elMinWidth');

const slidesPerView = 1;
const spaceBetween = 24;
const breakpoints = {
    540: {
        slidesPerView: 2,
    },
    768: {
        slidesPerView: 3,
    },
    1024: {
        slidesPerView: 4,
    },
};

const crossSellings = computed(() => elementData.getData('crossSellings') ?? []);

const onSelectProduct = async (product: Schemas['Product']) => {
    trackSelectItem(product, { id: 'cross-selling', name: 'cross-selling' });
};
</script>

<template>
    <ClientOnly>
        <template
            v-for="crossSelling in crossSellings"
            :key="crossSelling.crossSelling.id"
        >
            <h3 class="mt-8 text-3xl font-bold">
                {{ crossSelling.crossSelling.translated.name }}
            </h3>

            <!-- IDS-84 - change slider styles -->
            <LayoutSlider
                :classes="[crossSelling.products.length > 1 ?? 'cursor-grab']"
                :navigation-dots="true"
                :slides-per-view="slidesPerView"
                :space-between="spaceBetween"
                :breakpoints="breakpoints"
                :navigation-arrows="false"
            >
                <LayoutSliderSlide
                    v-for="slide in crossSelling.products"
                    :key="slide.id"
                    :class="`min-w-[${minWidth}] py-2`"
                >
                    <ProductCard
                        :product="slide"
                        :layout="boxLayout"
                        :display-mode="displayMode"
                        @select-product="onSelectProduct(slide)"
                    />
                </LayoutSliderSlide>
            </LayoutSlider>
        </template>
    </ClientOnly>
</template>
